module.exports = __webpack_public_path__ + "static/gorgon-997115955ed80796f627471911daa543.jpg";